import React from "react";
import ReactTooltip from "react-tooltip";

import {
    setJobTitle,
    setCareerCluster,
    setJobDescription,
    setIsGreen,
    setIsBright,
    setSkillLevel,
    setSearchType,
    setShowSkillLevels,
    setSelectedSkill,
    setSelectedIndex,
} from "../actions";

import green from "../images/green_lg.gif";
import bright from "../images/bf_med.png";

import { map } from "lodash";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";

// import * as skill_details from "../data/skill_details.json";

const course_levels = [
    { name: "Applied Math", key: "am", levels: [3, 4, 5, 6, 7] },
    { name: "Workplace Documents", key: "wd", levels: [3, 4, 5, 6, 7] },
    { name: "Graphic Literacy", key: "gl", levels: [3, 4, 5, 6, 7] },
    { name: "Applied Technology", key: "at", levels: [3, 4, 5, 6] },
    { name: "Business Writing", key: "bw", levels: [1, 2, 3, 4, 5] },
    { name: "Workplace Observation", key: "wo", levels: [1, 2, 3, 4, 5] },
];

const search_types = [
    "Best Matches",
    "Exact Matches",
    "Better Jobs",
    "All Qualified Jobs",
    "Higher Skilled Jobs",
];

const course_keys = map(course_levels, "key");

const SearchForm = ({
    jobTitle,
    careerCluster,
    jobDescription,
    isGreen,
    isBright,
    showSkillLevels,
    clusters,
    dispatch,
    ...props
}) => {
    function showSkillDetail(skill_tag) {
        dispatch(setSelectedIndex(null));
        dispatch(setSelectedSkill(skill_tag.toUpperCase()));
    }

    function handleFormChange(e) {
        let action, val;
        switch (e.target.name) {
            case "jobTitle":
                action = setJobTitle;
                val = e.target.value;
                break;
            case "careerCluster":
                action = setCareerCluster;
                val = e.target.value;
                break;
            case "jobDescription":
                action = setJobDescription;
                val = e.target.value;
                break;
            case "isGreen":
                action = setIsGreen;
                val = e.target.checked;
                break;
            case "isBright":
                action = setIsBright;
                val = e.target.checked;
                break;
            case "searchtype":
                action = setSearchType;
                val = e.target.value;
                break;
            default:
                if (course_keys.includes(e.target.name)) {
                    dispatch(setSkillLevel(e.target.name, e.target.value));
                }
                return;
        }

        dispatch(action(val));
    }

    // console.log(props);

    function toggleShowSkillLevels(e) {
        // console.log("toggleShowSkillLevels");
        e.preventDefault();
        dispatch(setShowSkillLevels(!showSkillLevels));
    }

    function clearJobTitle(e) {
        e.preventDefault();
        dispatch(setJobTitle(""));
    }

    function clearCareerCluster(e) {
        e.preventDefault();
        dispatch(setCareerCluster(""));
    }

    function clearJobDescription(e) {
        e.preventDefault();
        dispatch(setJobDescription(""));
    }

    function clearSkillLevels(e) {
        e.preventDefault();
        course_levels.forEach((course) =>
            dispatch(setSkillLevel(course.key, ""))
        );
        dispatch(setSearchType(1));
    }

    function clearFilters(e) {
        e.preventDefault();

        dispatch(setJobTitle(""));
        dispatch(setCareerCluster(""));
        dispatch(setJobDescription(""));

        dispatch(setIsGreen(0));
        dispatch(setIsBright(0));

        course_levels.forEach((course) =>
            dispatch(setSkillLevel(course.key, ""))
        );
        dispatch(setSearchType(1));
    }

    function formSubmit(e) {
        e.preventDefault();
    }

    return (
        <form onSubmit={formSubmit}>
            <fieldset className="search-fields">
                <legend>
                    Occupational Profile Search <br></br> (The occupational profiles represent local job profiles combined by O*NET number.)
                    <span className="col-1 float-right">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm float-right"
                            onClick={clearFilters}
                            data-tip="Reset all search criteria"
                        >
                            &times;
                        </button>
                        <ReactTooltip effect="solid" />
                    </span>
                </legend>
                <div className="container search-form pl-0">
                    <div className="row">
                        <div className="col-9">
                            <div className="form-row form-group">
                                <div className="col-3">
                                    <label htmlFor="jobTitle">
                                        Job Title / Code:
                                    </label>
                                </div>
                                <div className="col-8">
                                    <input
                                        type="text"
                                        name="jobTitle"
                                        className="form-control form-control-sm"
                                        value={jobTitle}
                                        onChange={handleFormChange}
                                    />
                                </div>
                                <div className="col-1">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={clearJobTitle}
                                    >
                                        &times;
                                    </button>
                                </div>
                            </div>
                            <div className="form-row form-group">
                                <div className="col-3">
                                    <label htmlFor="careerCluster">
                                        Career Cluster:
                                    </label>
                                </div>
                                <div className="col-8">
                                    <select
                                        name="careerCluster"
                                        className="form-control form-control-sm"
                                        value={careerCluster}
                                        onChange={handleFormChange}
                                    >
                                        <option value="" />
                                        {clusters.map((cluster) => (
                                            <option
                                                key={cluster.cluster_tag}
                                                value={cluster.cluster_tag}
                                            >
                                                {cluster.cluster_desc}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-1">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={clearCareerCluster}
                                    >
                                        &times;
                                    </button>
                                </div>
                            </div>
                            <div className="form-row form-group">
                                <div className="col-3">
                                    <label htmlFor="jobDescription">
                                        Job Description:
                                    </label>
                                </div>
                                <div className="col-8">
                                    <input
                                        type="text"
                                        name="jobDescription"
                                        className="form-control form-control-sm"
                                        value={jobDescription}
                                        onChange={handleFormChange}
                                    />
                                </div>
                                <div className="col-1">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={clearJobDescription}
                                    >
                                        &times;
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm show-only-box px-0">
                            <fieldset>
                                <legend>Show only:</legend>
                                <div className="container form-group">
                                    <div className="form-row">
                                        <input
                                            type="checkbox"
                                            name="isBright"
                                            className="form-check-input"
                                            value={1}
                                            checked={isBright === 1}
                                            onChange={handleFormChange}
                                        />
                                        <label
                                            htmlFor="isBright"
                                            className="form-check-label"
                                        >
                                            <img
                                                src={bright}
                                                alt="Bright Outlook"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </fieldset>
            <fieldset className="skill-levels">
                <legend>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={toggleShowSkillLevels}
                    >
                        <FontAwesomeIcon
                            icon={showSkillLevels ? faCaretUp : faCaretDown}
                        />
                    </button>
                    <span className="col-11" onClick={toggleShowSkillLevels}>
                        Search by <u><strong>Your</strong></u> Skill Levels {showSkillLevels}
                    </span>
                    <span className="col-1 float-right">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm float-right"
                            onClick={clearSkillLevels}
                            data-tip="Reset skill search"
                        >
                            &times;
                        </button>
                        <ReactTooltip effect="solid" />
                    </span>
                </legend>
                <div
                    className={`row skills collapse mx-0 ${
                        showSkillLevels ? "show" : ""
                    }`}
                >
                    <div className="col-sm">
                        <p>
                            An additional resource you can use is ACT’s <a href="https://success.act.org/s/article/Matching-Your-WorkKeys-Foundational-Skills-to-Jobs" target="_blank">Matching Your WorkKeys Foundational Skills to Jobs</a> coaching tool which provides a process to help you identify careers and think 
                            through needed training.  This tool is free to the public. 
                        </p>

           </div>
                    <div className="col-9 skill-areas">
                        <table className="table table-responsive-xl">
                            <thead>
                                <tr>
                                    <th className="p-0">Skill Area</th>
                                    <th className="p-0" />
                                    <th>NA</th>
                                    {Array(7)
                                        .fill()
                                        .map((_, i) => (
                                            <th key={i}>{i + 1}</th>
                                        ))}
                                    <th>Search Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {course_levels.map((course, course_ind) => (
                                    <tr key={course.key}>
                                        <td className="align-middle p-0 text-wrap text-left">
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-left"
                                                onClick={(e) =>
                                                    showSkillDetail(course.key)
                                                }
                                            >
                                                {course.name}
                                            </button>
                                        </td>
                                        <td className="align-middle p-0">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                onClick={(e) =>
                                                    showSkillDetail(course.key)
                                                }
                                                data-tip="click to browse descriptions of skill requirements"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faQuestionCircle}
                                                />
                                            </button>
                                            <ReactTooltip effect="solid" />
                                        </td>
                                        <td className="align-middle">
                                            <input
                                                type="radio"
                                                name={course.key}
                                                value=""
                                                checked={
                                                    props[course.key] === ""
                                                }
                                                onChange={handleFormChange}
                                            />
                                        </td>
                                        {Array(7)
                                            .fill()
                                            .map((_, i) => (
                                                <td
                                                    key={`${course.key}_${i}`}
                                                    className="align-middle"
                                                >
                                                    {course.levels.includes(
                                                        i + 1
                                                    ) ? (
                                                        <input
                                                            type="radio"
                                                            name={course.key}
                                                            value={i + 1}
                                                            checked={
                                                                props[
                                                                    course.key
                                                                ] ===
                                                                String(i + 1)
                                                            }
                                                            onChange={
                                                                handleFormChange
                                                            }
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                </td>
                                            ))}
                                        {course_ind === 0 ? (
                                            <td rowSpan={course_levels.length}>
                                                {search_types.map((st, i) => (
                                                    <div
                                                        className="row"
                                                        key={`searchtype_${i}`}
                                                    >
                                                        <div className="col">
                                                            <label
                                                                htmlFor={`searchtype_${i +
                                                                    1}`}
                                                            >
                                                                {st}:
                                                            </label>
                                                        </div>
                                                        <div className="col-1 px-0">
                                                            <input
                                                                type="radio"
                                                                name="searchtype"
                                                                id={`searchtype_${i +
                                                                    1}`}
                                                                value={i + 1}
                                                                checked={
                                                                    props.searchtype ===
                                                                    i + 1
                                                                }
                                                                onChange={
                                                                    handleFormChange
                                                                }
                                                            />
                                                        </div>
                                                        <div className="w-100" />
                                                    </div>
                                                ))}
                                            </td>
                                        ) : (
                                            <React.Fragment />
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </fieldset>
        </form>
    );
};

export default SearchForm;
